import React from 'react'

export const Qlik = () => (
  <path d='M1 7H19M7 19V7M3 1H17C18.1046 1 19 1.89543 19 3V17C19 18.1046 18.1046 19 17 19H3C1.89543 19 1 18.1046 1 17V3C1 1.89543 1.89543 1 3 1Z' />
)
